import React, { useState } from "react";
import {
  Grid,
  Avatar,
  Divider,
  Modal,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import apiRequest from "./../../../apiRequest";

function VehicleDetailModal({
  open,
  onClose,
  selectedVehicle,
  formatDate,
  onApprove,
  onReject,
}) {
  console.log("selectedVehicle", selectedVehicle)
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewSrc, setPreviewSrc] = useState("");

  if (!selectedVehicle) return null;

  const handleOpenPreview = (image) => {
    setPreviewSrc(image);
    setPreviewOpen(true);
  };

  return (
    <>
      {/* Main Detail Modal */}
      <Modal open={open} onClose={onClose} aria-labelledby="vehicle-detail-modal">
        <MDBox
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", md: "80%" },
            maxWidth: 900,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <MDTypography variant="h5" fontWeight="bold">
              Vehicle Details
            </MDTypography>
            <MDButton variant="outlined" color="secondary" onClick={onClose} size="small">
              Close
            </MDButton>
          </MDBox>

          <Grid container spacing={3}>
            {/* Owner Info */}
            <Grid item xs={6}>
              <MDBox mb={4}>
                <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                  Owner Information
                </MDTypography>
                <Divider />
                <MDBox mt={2} display="flex" alignItems="center" gap={3}>
                  <Avatar
                    src={`${apiRequest.BASE_URL}/${selectedVehicle.user?.profile}`}
                    sx={{ width: 80, height: 80 }}
                  />
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="medium">
                      {selectedVehicle.user?.full_name}
                    </MDTypography>
                    <MDTypography variant="body2" color="text">
                      Contact: {selectedVehicle.user?.contact}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>

            </Grid>

            <Grid item xs={6}>
              <MDBox mb={6}>
                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                  Qatar ID
                </MDTypography>
                <MDBox
                  onClick={() => handleOpenPreview(selectedVehicle.user?.user_taxes[0]?.pr_photo)}
                  sx={{
                    mb: 1,
                    cursor: "pointer",
                    "&:hover": { opacity: 0.8 },
                    display: "inline-block",
                  }}
                >
                  <Avatar
                    src={`${apiRequest.BASE_URL}/${selectedVehicle.user?.user_taxes[0]?.pr_photo}`}
                    variant="square"
                    sx={{ width: "50%", height: 200 }}
                  />
                </MDBox>
              </MDBox>

            </Grid>

          </Grid>


          {/* Vehicle Info */}
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <MDBox mb={4}>
                <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                  Vehicle Information
                </MDTypography>
                <Divider />
                {/* <MDBox mt={2}>
                  <InfoRow label="Make" value={selectedVehicle.vehicle_make} />
                  <InfoRow label="Model" value={`${selectedVehicle.vehicle_model} (${selectedVehicle.vehicle_year})`} />
                  <InfoRow label="Body Type" value={selectedVehicle.body_type} />
                  <InfoRow label="Number Plate" value={selectedVehicle.number_plate} />
                  <InfoRow label="Category" value={selectedVehicle.category?.name_en} />
                </MDBox> */}

                <MDBox mt={2}>
                  {selectedVehicle?.vehicle_make && (
                    <InfoRow label="Make" value={selectedVehicle.vehicle_make} />
                  )}

                  {(selectedVehicle?.vehicle_model || selectedVehicle?.vehicle_year) && (
                    <InfoRow
                      label="Model"
                      value={`${selectedVehicle.vehicle_model || ""} ${selectedVehicle.vehicle_year ? `(${selectedVehicle.vehicle_year})` : ""
                        }`}
                    />
                  )}

                  {selectedVehicle?.body_type && (
                    <InfoRow label="Body Type" value={selectedVehicle.body_type} />
                  )}

                  {selectedVehicle?.number_plate && (
                    <InfoRow label="Number Plate" value={selectedVehicle.number_plate} />
                  )}

                  {selectedVehicle?.category?.name_en && (
                    <InfoRow label="Category" value={selectedVehicle.category.name_en} />
                  )}
                </MDBox>

              </MDBox>
            </Grid>

            {/* Documents */}
            <Grid item xs={12} md={6}>
              <MDBox mb={4}>
                <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                  Documents
                </MDTypography>
                <Divider />
                {/* <MDBox mt={2}>
                  <MDTypography variant="button" fontWeight="medium" gutterBottom>
                    Vehicle Istamara
                  </MDTypography>
                  <MDBox
                    onClick={() => handleOpenPreview(selectedVehicle?.insurance_photo)}
                    sx={{
                      mb: 1,
                      cursor: "pointer",
                      "&:hover": { opacity: 0.8 },
                      display: "inline-block",
                    }}
                  >
                    <Avatar
                      src={`${apiRequest.BASE_URL}/${selectedVehicle.insurance_photo}`}
                      variant="square"
                      sx={{ width: "100%", height: 200 }}
                    />
                  </MDBox>
                  <MDTypography variant="caption" color="text">
                    Expires: {formatDate(selectedVehicle.insurance_expiration)}
                  </MDTypography>
                </MDBox> */}
                <MDBox mt={3} p={2} borderRadius="lg" sx={{ backgroundColor: "#fafafa" }}>
                  <MDTypography
                    variant="h6"
                    fontWeight="bold"
                    color="primary"
                    gutterBottom
                  >
                    Vehicle Istamara
                  </MDTypography>

                  <MDBox
                    onClick={() => handleOpenPreview(selectedVehicle?.insurance_photo)}
                    sx={{
                      mb: 1.5,
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: 2,
                      overflow: "hidden",
                      boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.02)",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                      },
                    }}
                  >
                    <Avatar
                      src={
                        selectedVehicle?.insurance_photo
                          ? `${apiRequest.BASE_URL}/${selectedVehicle.insurance_photo}`
                          : "/default-image.jpg"
                      }
                      alt="Vehicle Istamara"
                      variant="square"
                      sx={{
                        width: "100%",
                        height: 200,
                        objectFit: "cover",
                      }}
                    />
                  </MDBox>

                  <MDTypography variant="body2" color="text" sx={{ textAlign: "center" }}>
                    {/* <strong>Expires:</strong> {formatDate(selectedVehicle.insurance_expiration)} */}
                    <strong>Expires:</strong> {formatDate(selectedVehicle.expiration_date)}
                  </MDTypography>
                </MDBox>

              </MDBox>
            </Grid>
          </Grid>

          {/* Rejection Reason */}
          {selectedVehicle.reason_for_rejection && (
            <MDBox mt={3} p={2} bgcolor="error.light" borderRadius={1}>
              <MDTypography variant="h6" color="error" gutterBottom>
                Rejection Reason
              </MDTypography>
              <MDTypography variant="body2">
                {selectedVehicle.reason_for_rejection}
              </MDTypography>
            </MDBox>
          )}

          {/* Actions */}
          <MDBox mt={4} display="flex" justifyContent="flex-end">
            {selectedVehicle.status === "pending" && (
              <>
                <MDButton
                  variant="gradient"
                  color="error"
                  onClick={onReject}
                  sx={{ mr: 2 }}
                >
                  Reject
                </MDButton>
                <MDButton variant="gradient" color="info" onClick={onApprove}>
                  Approve
                </MDButton>
              </>
            )}
            {selectedVehicle.status === "approved" && (
              <MDButton variant="gradient" color="error" onClick={onReject}>
                Reject
              </MDButton>
            )}
          </MDBox>
        </MDBox>
      </Modal>

      {/* Image Preview Modal */}
      <Modal open={previewOpen} onClose={() => setPreviewOpen(false)}>
        <MDBox
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxWidth: "90vw",
            maxHeight: "90vh",
            bgcolor: "background.paper",
            p: 2,
            borderRadius: 2,
            boxShadow: 24,
            overflow: "auto",
          }}
        >
          <MDBox display="flex" justifyContent="flex-end" mb={2}>
            <MDButton
              size="small"
              variant="outlined"
              color="secondary"
              onClick={() => setPreviewOpen(false)}
            >
              Close
            </MDButton>
          </MDBox>
          <MDBox
            component="img"
            src={`${apiRequest.BASE_URL}/${previewSrc}`}
            alt="Insurance Preview"
            sx={{ width: "100%", height: "auto" }}
          />
        </MDBox>
      </Modal>
    </>
  );
}

// Reusable row
const InfoRow = ({ label, value }) => (
  <MDBox display="flex" justifyContent="space-between" mb={1}>
    <MDTypography variant="button" color="text">{label}:</MDTypography>
    <MDTypography variant="button" fontWeight="medium">{value || "N/A"}</MDTypography>
  </MDBox>
);

export default VehicleDetailModal;
